import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreen',
  setup(__props) {

// dorobic na animacje na close, transition

return { __sfc: true, }
}

})